var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.287,
    height: 24.286,
    viewBox: "0 0 24.287 24.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.869,
    y1: 0.817,
    x2: 0.147,
    y2: 0.153,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15a0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(17884.369 119.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M4.024,6.048H24.262a2.024,2.024,0,0,0,0-4.048H4.024a2.024,2.024,0,1,0,0,4.048Z",
    transform: "translate(-17886.369 -121.709)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M14.024,16.048H24.262a2.024,2.024,0,1,0,0-4.048H14.024a2.024,2.024,0,1,0,0,4.048Z",
    transform: "translate(-17886.369 -121.59)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M24.257,22H4.03a2.024,2.024,0,1,0,0,4.048H24.257a2.024,2.024,0,1,0,0-4.048Z",
    transform: "translate(-17886.369 -121.47)",
    fill: "url(#linear-gradient-3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRight);
export default __webpack_public_path__ + "static/media/menu-right.b76650ecc408ff10f3780458591fa601.svg";
export { ForwardRef as ReactComponent };